
/*
props:
* analysisAnswer:{
*   text: []
* }
* category 写作单独处理
* 写作需要传入
* myWriting: {text:}
*
* */
import React, { Component } from 'react';
import style from './answerAnalysis.css';
import { withRouter } from 'react-router'

@withRouter
export default class AnswerAnalysis extends Component {
  constructor() {
    super();
    this.state = {
      showWriting: false
    }
  }

  componentDidUpdate () {
    window.MathJax.Hub.Typeset()
  }

  shouldComponentUpdate(nextProps, nextState){
    return (
      nextProps.location.query.page !== this.props.location.query.page
      || nextState.showWriting !== this.state.showWriting
      || (this.props.analysisAnswer.text[0] && nextProps.analysisAnswer.text[0] && this.props.analysisAnswer.text[0].raw !== nextProps.analysisAnswer.text[0].raw)
     )
  }

  componentDidMount () {
    window.MathJax.Hub.Typeset()
  }

  handleClick = ()=> {
    this.setState({
      showWriting: !this.state.showWriting
    })
  }

  checkWordCount(inputStr) {
    var wordRegex = /(?:\b)?([\w]+?)\b/gmi;
    var specMatch = /([a-z]+?\'[a-z]+?\b)|(\$\d+(,\d+)+\b)/gmi;
    var match = null, wordCount = 0;
    inputStr = inputStr || '';
    inputStr = inputStr.replace(specMatch, 'combine');
    while ((match = wordRegex.exec(inputStr)) != null) {
      wordCount++;
    }
    return wordCount;
  }

  render() {
    const analysis = this.props.analysisAnswer;
    let showWriting = this.state.showWriting;
    let myWriting = this.props.myWriting ? this.props.myWriting.text : null;
    let analysisFlag = analysis.text && analysis.text.length > 0;
    if(this.props.category === 'writing') {
      let button = null;
      let title = null;
      if(myWriting) {
        if(analysisFlag) {
          button = (<span className={style.writingButton} onClick={this.handleClick}>{showWriting ?'查看我的写作':'查看文字解析'}</span>);
          title = (<div>
            <span className={style.writingTitle}>{showWriting ? '文字解析' : '我的作文'}</span>
            {showWriting ? null : <span className={style.wordCount}>Word Count {this.checkWordCount(myWriting)}</span>}
          </div>);
        }else {
          title = (<div><span className={style.writingTitle}>我的作文</span></div>);
        }
      }else {
        if(analysisFlag) {
          title = (<div><span className={style.writingTitle}>文字解析</span></div>)

        }
      }
      return(
        <div className={style.writingAnalysis}>
          {button}
          <div className={style.writingText}>
            {title}
            {showWriting ?
              analysis.text.map((item,index)=> {
                return (
                  <div key={index} dangerouslySetInnerHTML={{ __html: item.raw }} ></div>
                )
              })
              : <div className={style.myAnswer}>{myWriting}</div>
            }
          </div>
        </div>
      )
    }
    return (
      <div className={style.answerAnalysis}>
        {
          analysis.text && analysis.text.length > 0 ?
            <p className={style.analysisTitle}>答案解析</p>:
            null
        }
        <div className={style.analysisText}>
          {analysis.text.map((item,index)=> {
            return (
              <div style={{marginBottom: "20px"}} key={index} dangerouslySetInnerHTML={{ __html: item.raw }} ></div>
            )
          }) }
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Material/AnswerAnalysis.js
 **/